import { render, staticRenderFns } from "./LessonQuizItem.vue?vue&type=template&id=35b6c15d&scoped=true&"
import script from "./LessonQuizItem.vue?vue&type=script&lang=js&"
export * from "./LessonQuizItem.vue?vue&type=script&lang=js&"
import style0 from "./LessonQuizItem.vue?vue&type=style&index=0&id=35b6c15d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b6c15d",
  null
  
)

export default component.exports